@if (shouldUseCustomStyle) {
    <span class="custom-odds-value-style">{{ value }}</span>
} @else {
    {{ value }}
}
